import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useKeyboardShortcuts } from "../../../hooks/useKeyboardShortcuts";
import AdminCommandPalette from "./AdminCommandPalette";

/**
 * Global Cmd/Ctrl+K command palette host for the admin portal.
 *
 * Mounted once at App scope (next to SessionMilestoneTracker) so a single
 * instance serves every admin page without remounting on navigation. The
 * hotkey is armed only on /admin routes, so it never intercepts keys on
 * investor or public pages. Admin routes are already role-gated by
 * ProtectedRoute, so the path check is sufficient.
 */
const AdminCommandPaletteHost: React.FC = () => {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");
  const [open, setOpen] = useState(false);

  // Any navigation closes the palette so it never lingers or reopens stale
  // when crossing into/out of the admin section.
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // ignoreInputs:false so Cmd/Ctrl+K opens the palette even while a search box
  // or other input is focused, matching the original admin-home behavior.
  useKeyboardShortcuts(
    [
      { key: "meta+k", handler: () => setOpen(true), ignoreInputs: false, description: "Open admin command palette" },
      { key: "ctrl+k", handler: () => setOpen(true), ignoreInputs: false, description: "Open admin command palette" },
    ],
    { enabled: isAdminRoute }
  );

  if (!isAdminRoute) return null;

  return <AdminCommandPalette open={open} onClose={() => setOpen(false)} />;
};

export default AdminCommandPaletteHost;
